import { WarrantyRptConstants } from '../constants';

export function WarrantyRpt(state = {}, action) {
    switch (action.type) {
        case WarrantyRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case WarrantyRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case WarrantyRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case WarrantyRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case WarrantyRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case WarrantyRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case WarrantyRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}